var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 219,
    viewBox: "0 0 335 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.332 114.751C285.798 112.405 286.048 109.978 286.048 107.49C286.048 87.0928 269.522 70.5591 249.134 70.5591C246.52 70.5591 243.972 70.8371 241.514 71.3554C241.584 70.0879 241.627 68.811 241.627 67.5294C241.631 30.2356 211.41 0 174.129 0C144.609 0 119.535 18.965 110.365 45.3746C103.178 41.1151 94.7951 38.665 85.8374 38.665C59.214 38.665 37.6345 60.2544 37.6345 86.8902C37.6345 94.0757 39.217 100.884 42.0333 107.01C17.8212 113.582 0 135.7 0 161.982C0 193.429 25.5073 218.962 56.9534 218.962H314.833C326.687 207.837 334.086 192.034 334.086 174.492C334.086 144.996 313.147 120.396 285.332 114.751Z",
    fill: "url(#paint0_linear_1106_483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_483",
    x1: 167.043,
    y1: 0,
    x2: 167.043,
    y2: 218.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391559",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCloud);
export default __webpack_public_path__ + "static/media/about-us-cloud.fe15be797d916a045c4d4933c44611c6.svg";
export { ForwardRef as ReactComponent };